import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="py-16 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-146">
      <FadeIn data-id="element-147">
        <div className="text-center mb-10" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-4" data-id="element-149">
            El Choque Biológico Después de los 40
          </h2>
          <div className="w-24 h-1 bg-copper mx-auto rounded-full" data-id="element-150"></div>
        </div>

        <div className="space-y-6 text-lg text-warm-dark/80 font-sans leading-relaxed max-w-3xl mx-auto" data-id="element-151">
          <p data-id="element-152">
            Después de los 40 años, el declive del estrógeno no es solo un
            cambio de etapa; es un choque biológico. El cortisol (la hormona del
            estrés) se dispara, provocando que tu abdomen se inflame, que tu
            sueño desaparezca y que tu humor cambie de un segundo a otro sin
            previo aviso.
          </p>
          <p data-id="element-153">
            Intentar solucionar esto con dietas restrictivas o ejercicio intenso
            de 'cardio' solo empeora el problema. Tu cuerpo entra en modo
            pánico, guarda grasa y te agota aún más.
          </p>
          <p className="text-xl font-serif font-semibold text-rose-gold text-center mt-8 p-6 bg-blush/30 rounded-xl" data-id="element-154">
            Necesitas dejar de luchar contra tu biología y empezar a nutrirla
            desde la raíz.
          </p>
        </div>
      </FadeIn>
    </section>;
}